module.exports = __webpack_public_path__ + "static/media/wind-mill-red.d9f47fe7.svg";